import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.darkSage,
  tileBgColor: colors.eggShell,
  iconBgColor: colors.darkSage
};
export default imageGallery;